import { FETCH_SUGGESTIONS, FETCH_SEARCH } from './constants'

export const fetchSuggestions = {
  request: (query) => ({ type: FETCH_SUGGESTIONS.REQUEST, query }),
  success: (results) => ({ type: FETCH_SUGGESTIONS.SUCCESS, results })
}

export const fetchSearch = {
  request: (query, page) => ({ type: FETCH_SEARCH.REQUEST, query, page }),
  success: (results, total) => ({ type: FETCH_SEARCH.SUCCESS, results, total })
}
